import script from "./Auth0LogoutButton.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth0LogoutButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__